
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var UpgradePlanModel = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        UpgradePlanModel = BaseModel.extend({
            resource: ApiResources.CreateAccount.Upgrade,
            name: "UpgradePlanModel",
            defaults: {
                accountData: {
                    accountCreateData: {
                        url: ""
                    }
                },
                additionalParams: {
                    loggedInUserEmail: ""
                },
                registrationData: {
                    flow: "Subscription", // "Amendment"
                    billingData: {
                        ccRef: "",  // distinguishes trial from paying if provided.
                                    // If provided renders all other attributes to be mandatory
                        currencyCode: "USD"
                    },
                    productData: {  // mandatory for amendment
                        productName: "",
                        productRatePlanName: "",
                        productType: ""  //CATALOG|PERSONAL
                    },
                    crmData: {
                        firstName: "",
                        lastName: ""
                    }
                }
            }
        });
    });

    return UpgradePlanModel;
});

